import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { createDatagridSliceSelectors } from '../datagrid-slice.function';
import { createEntitySliceSelectors } from '../entity-slice.function';
import { FeatureName } from './feature';
import { ITiersStoreState } from './state';

export const selectState: MemoizedSelector<object, ITiersStoreState> = createFeatureSelector<ITiersStoreState>(FeatureName);

export const {
	selectEntity: selectTiers,
	selectIsLoading: selectTiersIsLoading,
	selectError: selectTiersError
} = createEntitySliceSelectors(createSelector(selectState, state => state.tiersForm));

export const {
	selectList: selectTiersList,
	selectSettings: selectTiersListSettings,
	selectIsLoading: selectTiersListIsLoading,
	selectError: selectTiersListError
} = createDatagridSliceSelectors(createSelector(selectState, state => state.tiersList));

export const getIsSubmitButtonDisabled = (state : ITiersStoreState): boolean => state.isSubmitButtonDisabled;
export const selectIsSubmitButtonDisabled = createSelector(selectState, state => getIsSubmitButtonDisabled(state));
